export const _homePageFr = {
    sgaTitle: 'Système de Gestion des Alertes',
    sgoTitle: 'Système de Gestion des Opérations',
    assignmentsTitle: 'Affectations',
    configTitle: 'Gérer la partie',
    alertConfigure: 'La partie doit être configurée avant de pouvoir être jouée.',
    shop: 'Boutique',
    alertAccess: 'Vous n\'avez pas accès à cette partie.',
};

export const _homePageEn = {
    sgaTitle: 'Alert Management System',
    sgoTitle: 'Operations Management System',
    assignmentsTitle: 'Assignments',
    configTitle: 'Configure the game',
    alertConfigure: 'The game must be configured before it can be played.',
    shop: 'Shop',
    alertAccess: 'You do not have access to this game.',
};

export const _homePageDe = {
    sgaTitle: 'Alarmverwaltungssystem',
    sgoTitle: 'Betriebsführungssystem',
    assignmentsTitle: 'Zuweisungen',
    configTitle: 'Spiel verwalten',
    alertConfigure: 'Das Spiel muss konfiguriert werden, bevor es gespielt werden kann.',
    shop: 'Geschäft',
    alertAccess: 'Sie haben keinen Zugriff auf dieses Spiel.',
};
